import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  Stack,
  Button,
  TableRow,
  TableCell,
  TableHead,
  TextField,
  TableBody,
  Typography,
  InputAdornment,
  TableContainer,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { RiFolder2Line } from "react-icons/ri";
import { AiOutlineFolderOpen } from "react-icons/ai";
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import {
  SelectProgramme,
  SelectAcademicYear,
  SelectStudentByAcademic,
  SelectStudentEnrollmentForInvoice,
} from "../Components/Include/DynamicSelect";
import CreateIcon from "../Assets/create-icon.svg";
import { padStartINV } from "../Function/DynamicFn";
import { AuthContext } from "../Context/AuthContext";
import EmptyData from "../Components/Include/EmptyData";
import { translateLauguage } from "../Function/Translate";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_LAST_INCOME_SHIFT } from "../Schema/IncomeBill";
import { GET_INVOICE_WITH_PAGEINATION } from "../Schema/Invoice";
import OpenIncomeShift from "../Components/Income/OpenIncomeShift";
import CloseIncomeShift from "../Components/Income/CloseIncomeShift";
import FooterPagination from "../Components/Include/FooterPagination";
import CreateReceipt from "../Components/Income/Receipt/CreateReceipt";
import GeneralIncomeAction from "../Components/Income/Invoice/GeneralIncomeAction";

export default function Income() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openOpenShift, setOpenOpenShift] = useState(false);
  const handleOpenOpenShift = () => setOpenOpenShift(true);

  const handleCloseShift = () => setOpenOpenShift(false);

  const [openCloseShift, setOpenCloseShift] = useState(false);
  const handleOpenCloseShift = () => setOpenCloseShift(true);
  const handleCloseCloseShift = () => setOpenCloseShift(false);

  const [programmVal, setProgrammVal] = useState({ id: "", title: "" });
  const [selectedStudent, setSelectedStudent] = useState({ id: "", title: "", data: null });
  const [classVal, setClassVal] = useState({ id: "", title: "", classId: "", enrollmentId: "", gradeId: "" });
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "", endDate: null, startDate: null });


  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [invoiceId, setInvoiceId] = useState();
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [incomeShiftData, setIncomeShiftData] = useState([]);

  useQuery(GET_LAST_INCOME_SHIFT, {
    onCompleted: ({ getLastIncomeShift }) => {
      setLoading(false);
      setIncomeShiftData(getLastIncomeShift);
    },
    onError: (err) => {
      console.log("Error", err?.message);
    },
  });

  // console.log("invoiceId::", invoiceId)

  const { refetch } = useQuery(GET_INVOICE_WITH_PAGEINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      classId: classVal?.id,
      programId: programmVal?.id,
      studentId: selectedStudent?.id,
      academicYearId: academicYearVal?.id,
      invoiceId: invoiceId ? parseInt(invoiceId) : null,
    },
    onCompleted: ({ getInvoiceWithPagination }) => {
      setTableData(getInvoiceWithPagination?.data);
      setPaginationData(getInvoiceWithPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
    setLoading(true);
  };

  const handleSearchInv = (e) => {
    setPage(1);
    setInvoiceId(e.target.value);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, keyword, invoiceId, classVal?.id, programmVal?.id, selectedStudent?.id, academicYearVal?.id]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/expense/disbursement">
            <Typography className="page-title">Receipt</Typography>
          </Link>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">Receipt</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container rowSpacing={1} columnSpacing={3}>
          <Grid item xs={6} sm={4} md={3} lg={1.5} xl={1.5}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              placeholder="Inv ID"
              size="small"
              type="number"
              className="search-field"
              onChange={(e) => handleSearchInv(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={1.5} xl={2}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              placeholder="Student name"
              size="small"
              className="search-field"
              onChange={(e) => handleSearch(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
            <Typography className="search-head-title">Academic year</Typography>
            <SelectAcademicYear
              className="search-field"
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className="search-head-title">Student</Typography>
            <SelectStudentByAcademic
              className="search-field"
              selectedVal={selectedStudent}
              setSelectedVal={setSelectedStudent}
              academicYearId={academicYearVal?.id}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2}>
            <Typography className="search-head-title">Programme</Typography>
            <SelectProgramme
              className="search-field"
              selectedVal={programmVal}
              setSelectedVal={setProgrammVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">class</Typography>

            <SelectStudentEnrollmentForInvoice
              className="search-field"
              selectedVal={classVal}
              setSelectedVal={setClassVal}

              programId={programmVal?.id}
              studentId={selectedStudent?.id}
              academicYearId={academicYearVal?.id}

            />
          </Grid>
          <Box flexGrow={1} />

          <Grid item xs={6} sm={4} md={8} lg={12} xl={12}>
            <Stack direction="row" spacing={2} justifyContent="right">
              {incomeShiftData === null || (incomeShiftData && incomeShiftData?.isClose === true) ? (
                <Button
                  onClick={handleOpenOpenShift}
                  className="btn-export"
                  startIcon={<RiFolder2Line />}
                >
                  Open Shift
                </Button>
              ) : (
                <Button
                  onClick={handleOpenCloseShift}
                  className="opening-shift"
                  startIcon={<AiOutlineFolderOpen size="25px" />}
                >
                  Shift Opening
                </Button>
              )}

              {/* {incomeShiftData?.isClose !== true ? ( */}
              {incomeShiftData !== null && incomeShiftData?.isClose !== true ? (
                <Button
                  onClick={handleOpen}
                  className="btn-export"
                  startIcon={
                    <img
                      src={CreateIcon}
                      alt="CreateIcon"
                      className="icon-add"
                    />
                  }
                >
                  {t("create")}
                </Button>
              ) : null}

              <OpenIncomeShift
                setRefetch={refetch}
                open={openOpenShift}
                handleClose={handleCloseShift}
              />

              <CloseIncomeShift
                setRefetch={refetch}
                open={openCloseShift}
                editData={incomeShiftData}
                handleClose={handleCloseCloseShift}
              />

              <CreateReceipt open={open} handleClose={handleClose} setRefetch={refetch} />

            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">N°</TableCell>
              <TableCell className="header-title">School Name</TableCell>
              <TableCell className="header-title">Receipt Number</TableCell>
              <TableCell className="header-title">Date</TableCell>
              <TableCell className="header-title">Name</TableCell>
              <TableCell className="header-title">Section</TableCell>
              <TableCell className="header-title">Discount</TableCell>
              <TableCell className="header-title">Total Amount</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={9} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={9} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        const totalAdditionalFee = row?.additionalFee.reduce((a, b) => a + b.total || 0, 0);
                        const totalDiscountAmount = row?.additionalFee.reduce((a, b) => a + b.discount || 0, 0);
                        return (
                          <TableRow className={"body-row"} key={index} >
                            <TableCell className="body-cell-start" sx={{ color: "#0f81c2 !important" }} >
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.schoolId?.schoolName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {padStartINV(row?.invoiceId)}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.paymentDate).format("DD-MMM-YYYY")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.studentId?.lastName + " " + row?.studentId?.firstName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.classId?.gradeId?.gradeName || "" + " " + row?.classId?.className || ""}
                            </TableCell>
                            <TableCell className="body-cell">
                              $ {totalDiscountAmount + row?.discountAmount || 0}
                            </TableCell>
                            <TableCell className="body-cell">
                              $ {totalAdditionalFee + row?.netAmount || 0}
                            </TableCell>
                            <TableCell className="body-cell-end">
                              <GeneralIncomeAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
